<p-toast />
<p-confirmDialog></p-confirmDialog>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>
<app-shipment-commercial-party-correction [shipment]="shipment"
    (corrected)="onBillToPartyCorrected()"></app-shipment-commercial-party-correction>
<app-shipment-schedule-correction [shipment]="shipment"
    (corrected)="onScheduleCorrected()"></app-shipment-schedule-correction>

<p-dialog [header]="'pages.shipmentDetail.requestedTrucksModal.header' | transloco" [(visible)]="requestedTruckCountDialogVisible" [modal]="true"
    [draggable]="false" [resizable]="false" [closable]="!requestedTruckCountSaving"
    [style]="{ width: 'min(760px, 94vw)' }" [breakpoints]="{ '860px': '96vw' }"
    styleClass="master-create-dialog requested-trucks-dialog"
    (onHide)="closeRequestedTruckCountDialog()">
    <section class="master-dialog-body requested-trucks-body">
        <aside class="master-dialog-summary">
            <div class="summary-icon"><i class="pi pi-truck"></i></div>
            <div>
                <small>{{ 'pages.shipmentDetail.requestedTrucksModal.eyebrow' | transloco }}</small>
                <h3>{{ shipment?.shipmentNumber }}</h3>
                <p>{{ 'pages.shipmentDetail.requestedTrucksModal.lead' | transloco }}</p>
            </div>
            <div class="master-dialog-facts">
                <div><span>Currently requested</span><strong>{{ shipment?.quantityRequired || 1 }}</strong></div>
                <div><span>Existing jobs</span><strong>{{ orderJobList.length }}</strong></div>
                <div><span>Deliveries</span><strong>{{ orderDeliveryList.length }}</strong></div>
                <div><span>Minimum allowed</span><strong>{{ minimumRequestedTruckCount() }}</strong></div>
            </div>
        </aside>
        <div class="master-dialog-form requested-trucks-form">
            <div class="master-wide-field requested-trucks-intro">
                <h4>Requested capacity</h4>
                <p>Choose the total number of trucks needed for this shipment.</p>
            </div>
            <p-inputGroup class="master-wide-field">
                <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-inputNumber inputId="requestedTruckCount" [(ngModel)]="requestedTruckCountDraft"
                        (ngModelChange)="requestedTruckCountError = ''"
                        [min]="minimumRequestedTruckCount()" [minFractionDigits]="0" [maxFractionDigits]="0"
                        [useGrouping]="false" [showButtons]="true" styleClass="w-full"
                        [disabled]="requestedTruckCountSaving"></p-inputNumber>
                    <label for="requestedTruckCount">Requested trucks *</label>
                </p-iftalabel>
            </p-inputGroup>
            <small class="master-wide-field requested-trucks-hint">Minimum {{ minimumRequestedTruckCount() }} to keep all existing jobs and deliveries.</small>
            <small *ngIf="requestedTruckCountError" class="p-error master-wide-field save-error" role="alert">{{ requestedTruckCountError }}</small>
        </div>
    </section>
    <ng-template #footer>
        <div class="master-dialog-footer">
            <span class="footer-spacer"></span>
            <p-button [label]="'pages.shipmentDetail.requestedTrucksModal.cancel' | transloco" icon="pi pi-times" severity="secondary" [outlined]="true"
                [disabled]="requestedTruckCountSaving" (onClick)="closeRequestedTruckCountDialog()"></p-button>
            <p-button [label]="'pages.shipmentDetail.requestedTrucksModal.save' | transloco" icon="pi pi-save" [loading]="requestedTruckCountSaving"
                (onClick)="saveRequestedTruckCount()"></p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- A failed or partial load must not render bindings such as shipment.shipmentNumber. -->
<app-page-shell *ngIf="!isLoading && shipment">

    <app-page-detail-hero [auditStamp]="shipmentAuditStamp()"
        [eyebrow]="'pages.shipmentDetail.hero.eyebrow' | transloco"
        [title]="'pages.shipmentDetail.hero.title' | transloco:{ number: shipment.shipmentNumber }"
        [subtitle]="(shipment.sourceLocation?.name || pickupLocality || ('pages.shipmentDetail.hero.sourceFallback' | transloco)) + ' ' + ('pages.shipmentDetail.common.to' | transloco) + ' ' + (shipment.destinationLocation?.name || dropoffLocality || ('pages.shipmentDetail.hero.destinationFallback' | transloco))"
        icon="fa-solid fa-truck-fast">
        <div tags class="shipment-hero-tags">
            <div class="shipment-hero-status" [ngClass]="shipmentHeroStatusClass()">
                <span><i [class]="shipmentHeroStatusIcon()"></i> {{ 'pages.shipmentDetail.hero.statusLabel' | transloco }}</span>
                <strong>{{ formatStatusLabel(shipment.workflowState || shipment.shipmentStatus) }}</strong>
            </div>
            <div class="shipment-hero-meta-tags">
                <p-tag [value]="shipment.routeType || 'DOMESTIC'" severity="info"></p-tag>
                <p-tag [value]="serviceCategoryLabel()" severity="warn"></p-tag>
                <p-tag [value]="shipment.billingMode === 'CONSOLIDATED_ZERO_SELL' ? 'Billing: shared · zero sell' : shipment.billingMode === 'CONSOLIDATED_PER_PARTY' ? 'Billing: shared · per party' : 'Billing: standard'" severity="info"></p-tag>
                <p-tag *ngIf="hasLogisticsProject()" [value]="logisticsProjectTagLabel()" severity="contrast"></p-tag>
            </div>
        </div>
        <div actions>
            <p-button [label]="'pages.shipmentDetail.hero.backToShipments' | transloco" icon="pi pi-arrow-left"
                severity="secondary" [outlined]="true" routerLink="/shipment/company"></p-button>
        </div>
    </app-page-detail-hero>

    <div class="cancellation-alert-banner" *ngIf="isCancelledShipment()">
        <i class="fa-solid fa-ban"></i>
        <div class="cancellation-alert-copy">
            <strong>This shipment has been cancelled.</strong>
            <span>All associated deliveries have been cancelled automatically, and further actions on this shipment are locked.</span>
        </div>
    </div>

    <div class="cancellation-alert-banner" *ngFor="let request of returnWarehouseBlockers" role="alert">
        <i class="pi pi-exclamation-triangle"></i>
        <div class="cancellation-alert-copy">
            <strong>{{ 'pages.shipmentDetail.returnWarehouseBlocker.title' | transloco:{ stopId: request.returnStopId } }}</strong>
            <span>{{ 'pages.shipmentDetail.returnWarehouseBlocker.description' | transloco }}</span>
        </div>
    </div>

    @if (shipmentInboundRequests.length) {
    <section class="surface-card border-1 surface-border border-round p-3 mb-3" aria-label="Inbound warehouse work">
        <strong>Inbound warehouse work</strong>
        @for (request of shipmentInboundRequests; track request.id) {
        <div class="flex flex-wrap align-items-center gap-3 mt-2">
            <span>Warehouse #{{ request.warehouseId }} · {{ request.status }}</span>
            @for (line of request.lines; track line.id) {
                @if (line.inboundReceiptId) {
                <a [routerLink]="['/warehousing/stock-entry/view', line.inboundReceiptId]">{{ line.receiptNumber || ('GRN #' + line.inboundReceiptId) }}</a>
                }
            }
        </div>
        }
    </section>
    }

    <div class="shipment-detail-layout">
        <main class="shipment-detail-main">
    <div class="accounts-posting-summary" *ngIf="accountsPostingResult">
        <span><i class="pi pi-check-circle"></i> {{ 'pages.shipmentDetail.actions.postToAccountsSuccess' | transloco }}</span>
        <div class="accounts-revenue-skip"
            *ngIf="accountsPostingResult.channelOutcomes['RECEIVABLE'] === 'SKIPPED_SALES_ORDER_CLAIM'">
            <i class="pi pi-info-circle"></i>
            Receivable skipped; customer revenue is handled by sales order
            <strong>{{ accountsPostingResult.channelOutcomes['RECEIVABLE_CLAIM_DOCUMENT'] || 'already created' }}</strong>.
        </div>
        <div class="accounts-revenue-skip"
            *ngIf="accountsPostingResult.channelOutcomes['SISTER_COST_RECONCILIATION'] === 'REQUIRED_POSTED_BULK_COST'">
            <i class="pi pi-exclamation-triangle"></i>
            A truck cost was already posted in the shipment company. Finance must reconcile it before posting cost or a payable in the truck-owning company.
        </div>
        <div class="accounts-revenue-skip"
            *ngIf="accountsPostingResult.channelOutcomes['TRUCK_OWNER_RECONCILIATION'] === 'LEGACY_SHIPMENT_COMPANY_DOCUMENT'
                && accountsPostingResult.channelOutcomes['SISTER_COST_RECONCILIATION'] !== 'REQUIRED_POSTED_BULK_COST'">
            <i class="pi pi-exclamation-triangle"></i>
            A delivery cost or payable still belongs to the shipment company. Finance must reconcile it before posting in the truck-owning company.
        </div>
        <div class="accounts-revenue-skip" *ngIf="accountsPostingResult.channelOutcomes['FINANCE_RECONCILIATION']">
            <i class="pi pi-exclamation-triangle"></i>
            {{ accountsPostingResult.channelOutcomes['FINANCE_RECONCILIATION'] }}
        </div>
        <p-button *ngIf="accountsPostingResult.bulkCostIds.length"
            [label]="('pages.shipmentDetail.actions.bulkCostDocuments' | transloco:{ count: accountsPostingResult.bulkCostIds.length })"
            icon="fa-solid fa-receipt" severity="secondary" [outlined]="true"
            [routerLink]="['/accounts/payables/bulk-costs']"></p-button>
        <p-button *ngIf="accountsPostingResult.receivableIds.length"
            [label]="('pages.shipmentDetail.actions.receivableDocuments' | transloco:{ count: accountsPostingResult.receivableIds.length })"
            icon="fa-solid fa-file-invoice-dollar" severity="secondary" [outlined]="true"
            [routerLink]="['/accounts/receivables/to-be-invoiced']"></p-button>
        <p-button *ngIf="accountsPostingResult.payableIds.length"
            [label]="('pages.shipmentDetail.actions.payableDocuments' | transloco:{ count: accountsPostingResult.payableIds.length })"
            icon="fa-solid fa-file-invoice" severity="secondary" [outlined]="true"
            [routerLink]="['/accounts/payables/to-be-billed']"></p-button>
    </div>

    <app-page-metric-strip [metrics]="shipmentMetrics()"></app-page-metric-strip>

    <app-page-data-panel [title]="'pages.shipmentDetail.workspace.title' | transloco" [subtitle]="'pages.shipmentDetail.workspace.subtitle' | transloco">
        <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange({ index: $event })" styleClass="shipment-workspace-tabs">
            <p-tablist>
                <p-tab [value]="0">
                    <span class="workspace-tab"><i class="fa-solid fa-gauge-high"></i><span>{{ 'pages.shipmentDetail.workspace.tabs.overview' | transloco }}</span></span>
                </p-tab>
                <p-tab [value]="1">
                    <span class="workspace-tab">
                        <i class="fa-solid fa-route"></i><span>{{ 'pages.shipmentDetail.workspace.tabs.route' | transloco }}</span>
                        <p-badge [value]="waypointList.length.toString()" severity="info"></p-badge>
                    </span>
                </p-tab>
                <p-tab [value]="2">
                    <span class="workspace-tab">
                        <i class="fa-solid fa-truck-ramp-box"></i><span>{{ 'pages.shipmentDetail.workspace.tabs.dispatch' | transloco }}</span>
                        <p-badge [value]="(orderDeliveryList.length + orderJobList.length).toString()"
                            [severity]="(orderDeliveryList.length + orderJobList.length) > 0 ? 'success' : 'danger'"></p-badge>
                    </span>
                </p-tab>
                <p-tab [value]="3">
                    <span class="workspace-tab">
                        <i class="fa-solid fa-boxes-stacked"></i><span>{{ 'pages.shipmentDetail.workspace.tabs.payload' | transloco }}</span>
                        <p-badge [value]="payloadCount().toString()" [severity]="payloadCount() > 0 ? 'info' : 'secondary'"></p-badge>
                    </span>
                </p-tab>
                <p-tab [value]="4" *ngIf="canViewShipmentPricing()">
                    <span class="workspace-tab">
                        <i class="fa-solid fa-money-bill-trend-up"></i><span>{{ 'pages.shipmentDetail.workspace.tabs.financials' | transloco }}</span>
                        <p-badge [value]="(shipment?.chargeLines?.length ?? 0).toString()"
                            [severity]="(shipment?.chargeLines?.length ?? 0) > 0 ? 'info' : 'danger'"></p-badge>
                    </span>
                </p-tab>
                <p-tab [value]="5">
                    <span class="workspace-tab">
                        <i class="fa-solid fa-paperclip"></i><span>{{ 'pages.shipmentDetail.workspace.tabs.files' | transloco }}</span>
                        <p-badge [value]="orderFilesCount.toString()" [severity]="orderFilesCount > 0 ? 'success' : 'info'"></p-badge>
                    </span>
                </p-tab>
                <p-tab [value]="6">
                    <span class="workspace-tab">
                        <i class="fa-solid fa-users"></i><span>{{ 'pages.shipmentDetail.workspace.tabs.people' | transloco }}</span>
                        <p-badge [value]="nominationEntities.length.toString()" severity="success"></p-badge>
                    </span>
                </p-tab>
                <p-tab [value]="7">
                    <span class="workspace-tab">
                        <i class="fa-solid fa-note-sticky"></i><span>{{ 'pages.shipmentDetail.workspace.tabs.notes' | transloco }}</span>
                    </span>
                </p-tab>
            </p-tablist>

            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <section class="workspace-section overview-workspace-section">
                        <div class="overview-dashboard-grid">
                            <div class="overview-main-column">
                        @if (showRouteEndpointBoard()) {
                        <div class="route-board">
                            <div class="route-endpoint">
                                <span class="endpoint-kicker">{{ 'pages.shipmentDetail.overview.pickup' | transloco }}</span>
                                <h3>{{ shipment.sourceLocation?.name || ('pages.shipmentDetail.common.sourceLocation' | transloco) }}</h3>
                                <a class="endpoint-address"
                                    href="https://maps.google.com?q={{ shipment.sourceLocation?.location?.latitude }},{{ shipment.sourceLocation?.location?.longitude }}"
                                    target="_blank">{{ pickupSubLocality || getShortAddress(shipment.sourceLocation?.address) || ('pages.shipmentDetail.common.openMap' | transloco) }}, {{ pickupLocality }}</a>
                                <div class="endpoint-schedule">
                                    <span>{{ 'pages.shipmentDetail.overview.pickupTime' | transloco }}</span>
                                    <strong>{{ pickupScheduleLabel() || ('pages.shipmentDetail.common.notScheduled' | transloco) }}</strong>
                                </div>
                            </div>
                            <div class="route-connector">
                                <span></span>
                                <i class="fa-solid fa-truck-fast"></i>
                                <span></span>
                            </div>
                            <div class="route-endpoint destination">
                                <span class="endpoint-kicker">{{ 'pages.shipmentDetail.overview.dropoff' | transloco }}</span>
                                <h3>{{ shipment.destinationLocation?.name || ('pages.shipmentDetail.common.destinationLocation' | transloco) }}</h3>
                                <a class="endpoint-address"
                                    href="https://maps.google.com?q={{ shipment.destinationLocation?.location?.latitude }},{{ shipment.destinationLocation?.location?.longitude }}"
                                    target="_blank">{{ dropoffSubLocality || getShortAddress(shipment.destinationLocation?.address) || ('pages.shipmentDetail.common.openMap' | transloco) }}, {{ dropoffLocality }}</a>
                                <div class="endpoint-schedule">
                                    <span>{{ 'pages.shipmentDetail.overview.deliveryTime' | transloco }}</span>
                                    <strong>{{ deliveryScheduleLabel() || ('pages.shipmentDetail.common.notScheduled' | transloco) }}</strong>
                                </div>
                            </div>
                        </div>
                        }

                        @if (showRouteSummaryCards()) {
                        <div class="route-summary-grid">
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.totalStops' | transloco }}</span>
                                <strong>{{ waypointList.length }}</strong>
                            </div>
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.intermediate' | transloco }}</span>
                                <strong>{{ intermediateWaypointCount() }}</strong>
                            </div>
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.pickups' | transloco }}</span>
                                <strong>{{ waypointTypeCount('PICKUP') }}</strong>
                            </div>
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.dropoffs' | transloco }}</span>
                                <strong>{{ waypointTypeCount('DROPOFF') }}</strong>
                            </div>
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.crossDock' | transloco }}</span>
                                <strong>{{ waypointTypeCount('CROSS_DOCK') }}</strong>
                            </div>
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.restAreas' | transloco }}</span>
                                <strong>{{ waypointTypeCount('REST_AREA') }}</strong>
                            </div>
                        </div>
                        }

                        @if (shipmentWaybillsLoading) {
                        <div class="shipment-secondary-state" role="status">Loading waybills…</div>
                        } @else if (shipmentWaybillsError) {
                        <div class="shipment-secondary-state shipment-secondary-state--error" role="alert">
                            Waybills could not be loaded. <button type="button" (click)="retryShipmentWaybills()">Retry</button>
                        </div>
                        }
                        @if (shipmentWaybillSummary.deliveries.length > 0) {
                        <section class="waybill-summary-card" aria-label="Waybills by delivery and site">
                            <div class="section-toolbar"><div><h3>{{ 'pages.shipmentDetail.overview.waybills' | transloco }}</h3><p>Issued waybills grouped by delivery and site.</p></div></div>
                            @for (delivery of shipmentWaybillSummary.deliveries; track delivery.deliveryId) {
                            <div class="waybill-delivery-group">
                                <strong>{{ delivery.deliveryNumber || ('Delivery #' + delivery.deliveryId) }}</strong>
                                @for (site of delivery.sites; track site.stopId) {
                                <div class="waybill-site-row">
                                    <span>{{ site.stopType || 'SITE' }} {{ site.stopNumber ? ('#' + site.stopNumber) : '' }} · {{ site.locationName || 'Location pending' }}</span>
                                    @if (site.issued) { <p-tag [value]="site.waybillNumbers.join(', ')" severity="success"></p-tag> }
                                    @else { <p-tag [value]="'pages.shipmentDetail.overview.noWaybillIssued' | transloco" severity="secondary"></p-tag> }
                                </div>
                                }
                            </div>
                            }
                        </section>
                        }

                        <div class="overview-header-metadata">
                            @if (showRouteSummaryCards()) {
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.pickupTime' | transloco }}</span>
                                <strong>{{ pickupScheduleLabel() || ('pages.shipmentDetail.common.notScheduled' | transloco) }}</strong>
                            </div>
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.deliveryTime' | transloco }}</span>
                                <strong>{{ deliveryScheduleLabel() || ('pages.shipmentDetail.common.notScheduled' | transloco) }}</strong>
                            </div>
                            }
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.priority' | transloco }}</span>
                                <p-tag [value]="priorityLabel()" [severity]="prioritySeverity()"></p-tag>
                            </div>
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.serviceCategory' | transloco }}</span>
                                <strong>{{ serviceCategoryLabel() }}</strong>
                            </div>
                            @if (shipment.externalReference) {
                            <div>
                                <span>{{ 'pages.shipmentDetail.overview.reference' | transloco }}</span>
                                <strong>{{ shipment.externalReference }}</strong>
                            </div>
                            }
                        </div>

                        @if (intermediateWaypointCount() > 0) {
                        <div class="stops-contact-panel">
                            <div class="section-toolbar">
                                <div>
                                    <h3>{{ 'pages.shipmentDetail.overview.stopsAndSiteContacts' | transloco }}</h3>
                                    <p>{{ 'pages.shipmentDetail.overview.stopsSummary' | transloco:{ intermediate: intermediateWaypointCount(), total: waypointList.length } }}</p>
                                </div>
                            </div>

                            @if (waypointList.length > 0) {
                            <div class="stop-contact-list">
                                @for (waypoint of waypointList; track waypoint.waypointId || $index) {
                                <article class="stop-contact-row">
                                    <div class="stop-contact-marker">{{ waypoint.waypointNumber || $index + 1 }}</div>
                                    <div class="stop-contact-location">
                                        <div class="stop-contact-title">
                                            <strong>{{ waypoint.location?.name || ('pages.shipmentDetail.common.locationPending' | transloco) }}</strong>
                                            <p-tag [value]="waypointDisplayType(waypoint)" [severity]="waypointTypeSeverity(waypoint)"></p-tag>
                                        </div>
                                        @if (routeWaypointMapsUrl(waypoint); as waypointMapUrl) {
                                        <a [href]="waypointMapUrl" target="_blank">{{ waypointShortAddress(waypoint) }}</a>
                                        } @else {
                                        <span>{{ waypointShortAddress(waypoint) }}</span>
                                        }
                                        <div class="stop-contact-meta">
                                            <span>{{ waypoint.status || ('pages.shipmentDetail.common.planned' | transloco) }}</span>
                                            <span>{{ waypointScheduleLabel(waypoint) }}</span>
                                        </div>
                                    </div>
                                    <div class="stop-contact-person">
                                        <p-avatar [image]="waypointContact(waypoint)?.imageUrl || 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'"
                                            shape="circle"></p-avatar>
                                        <div>
                                            <strong>{{ waypointContact(waypoint)?.name || ('pages.shipmentDetail.common.contactNotAssigned' | transloco) }}</strong>
                                            <span>{{ waypointContactCompany(waypoint) }}</span>
                                            <small>{{ waypointPhone(waypoint) }}</small>
                                        </div>
                                    </div>
                                </article>
                                }
                            </div>
                            } @else {
                            <div class="empty-state compact-empty">
                                <i class="fa-solid fa-route"></i>
                                <strong>{{ 'pages.shipmentDetail.overview.noRouteStops' | transloco }}</strong>
                                <span>{{ 'pages.shipmentDetail.overview.noRouteStopsHint' | transloco }}</span>
                            </div>
                            }
                        </div>
                        }

                        <div class="overview-grid">
                            @if (intermediateWaypointCount() === 0) {
                            <div class="info-block party-block">
                                <div class="block-heading"><i class="fa-solid fa-flag-checkered"></i><span>{{ 'pages.shipmentDetail.overview.sender' | transloco }}</span></div>
                                @if (shipment?.nominationPack?.sender) {
                                <div class="person-line">
                                    <p-avatar [image]="shipment.nominationPack.sender.nominee?.imageUrl || 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'"
                                        shape="circle"></p-avatar>
                                    <div>
                                        <strong>{{ shipment.nominationPack.sender.nominee?.name || 'Sender contact pending' }}</strong>
                                        <span>{{ shipment.nominationPack.sender.client?.name || 'Sender company pending' }}</span>
                                    </div>
                                </div>
                                <dl>
                                    <div><dt>{{ 'pages.shipmentDetail.overview.mobile' | transloco }}</dt><dd>{{ shipment.nominationPack.sender.nominee?.phoneNumber || ('pages.shipmentDetail.common.notAvailable' | transloco) }}</dd></div>
                                    <div><dt>{{ 'pages.shipmentDetail.overview.site' | transloco }}</dt><dd>{{ shipment.sourceLocation?.name || ('pages.shipmentDetail.common.sourceLocation' | transloco) }}</dd></div>
                                    <div><dt>{{ 'pages.shipmentDetail.overview.address' | transloco }}</dt><dd>{{ pickupSubLocality || '' }}{{ pickupSubLocality && pickupLocality ? ', ' : '' }}{{ pickupLocality || ('pages.shipmentDetail.common.notAvailable' | transloco) }}</dd></div>
                                </dl>
                                } @else {
                                <p class="empty-copy">{{ 'pages.shipmentDetail.overview.noSenderInfo' | transloco }}</p>
                                }
                            </div>

                            <div class="info-block party-block">
                                <div class="block-heading"><i class="fa-solid fa-flag"></i><span>{{ 'pages.shipmentDetail.overview.receiver' | transloco }}</span></div>
                                @if (shipment?.nominationPack?.receiver) {
                                <div class="person-line">
                                    <p-avatar [image]="shipment.nominationPack.receiver.nominee?.imageUrl || 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'"
                                        shape="circle"></p-avatar>
                                    <div>
                                        <strong>{{ shipment.nominationPack.receiver.nominee?.name || 'Receiver contact pending' }}</strong>
                                        <span>{{ shipment.nominationPack.receiver.client?.name || 'Receiver company pending' }}</span>
                                    </div>
                                </div>
                                <dl>
                                    <div><dt>{{ 'pages.shipmentDetail.overview.mobile' | transloco }}</dt><dd>{{ shipment.nominationPack.receiver.nominee?.phoneNumber || ('pages.shipmentDetail.common.notAvailable' | transloco) }}</dd></div>
                                    <div><dt>{{ 'pages.shipmentDetail.overview.site' | transloco }}</dt><dd>{{ shipment.destinationLocation?.name || ('pages.shipmentDetail.common.destinationLocation' | transloco) }}</dd></div>
                                    <div><dt>{{ 'pages.shipmentDetail.overview.address' | transloco }}</dt><dd>{{ dropoffSubLocality || '' }}{{ dropoffSubLocality && dropoffLocality ? ', ' : '' }}{{ dropoffLocality || ('pages.shipmentDetail.common.notAvailable' | transloco) }}</dd></div>
                                </dl>
                                } @else {
                                <p class="empty-copy">{{ 'pages.shipmentDetail.overview.noReceiverInfo' | transloco }}</p>
                                }
                            </div>
                            }

                            <div class="info-block business-context-block">
                                <div class="block-heading"><i class="fa-solid fa-building-user"></i><span>{{ 'pages.shipmentDetail.overview.businessContext' | transloco }}</span></div>
                                @if (isZeroSellConsolidation()) {
                                <p class="shared-shipment-copy">Shared shipment for multiple bill-to parties. Selling is zero at shipment level; each linked release retains its own client context.</p>
                                @if (consolidationLoading) {
                                <div class="shipment-secondary-state" role="status">Loading participating clients…</div>
                                } @else if (consolidationError) {
                                <div class="shipment-secondary-state shipment-secondary-state--error" role="alert">Participating clients could not be loaded. <button type="button" (click)="retryConsolidation()">Retry</button></div>
                                } @else if (consolidation?.sourceStatus === 'UNAVAILABLE') {
                                <div class="shipment-secondary-state">Participating clients are unavailable for this shipment.</div>
                                } @else if (consolidation) {
                                <div class="consolidation-counts" aria-label="Consolidation counts">
                                    <div><strong>{{ consolidation.clientCount }}</strong><span>Clients</span></div>
                                    <div><strong>{{ consolidation.partyCount }}</strong><span>Bill-to parties</span></div>
                                    <div><strong>{{ consolidation.releaseCount }}</strong><span>Order releases</span></div>
                                </div>
                                @if (consolidation.sourceStatus === 'RECONSTRUCTED') {<p class="consolidation-note">Reconstructed from payload links; no commercial allocation snapshot is available.</p>}
                                <div class="consolidation-client-cards">
                                    @for (client of consolidation.clients; track client.key) {
                                    <div class="consolidation-client-card"><strong>{{ client.name }}</strong><span>{{ client.parties.length }} bill-to {{ client.parties.length === 1 ? 'party' : 'parties' }} · {{ client.releaseCount }} {{ client.releaseCount === 1 ? 'release' : 'releases' }}</span></div>
                                    }
                                </div>
                                }
                                } @else {
                                <div class="business-context-grid">
                                    <div>
                                        <span>{{ 'pages.shipmentDetail.overview.createdBy' | transloco }}</span>
                                        <strong>{{ shipmentOwningContactLabel() }}</strong>
                                    </div>
                                    @if (hasCrmCommercialContext()) {
                                        <div>
                                            <span>CRM Client</span>
                                            <strong>{{ shipmentCrmClientLabel() }}</strong>
                                        </div>
                                        @if (hasCrmAccountContext()) {
                                            <div>
                                                <span>CRM Account</span>
                                                <strong>{{ shipmentCrmAccountLabel() }}</strong>
                                            </div>
                                        } @else {
                                            <div>
                                                <span>Sub-party</span>
                                                <strong>{{ shipmentCompanyLabel() }}</strong>
                                            </div>
                                        }
                                        <div>
                                            <span>CRM Client Contact</span>
                                            <strong>{{ shipmentCrmClientContactLabel() }}</strong>
                                        </div>
                                    } @else {
                                        <div>
                                            <span>{{ 'pages.shipmentDetail.overview.customerCompany' | transloco }}</span>
                                            <strong>{{ shipmentCompanyLabel() }}</strong>
                                        </div>
                                        <div>
                                            <span>{{ 'pages.shipmentDetail.overview.customerContact' | transloco }}</span>
                                            <strong>{{ shipmentCustomerLabel() }}</strong>
                                        </div>
                                    }
                                    <div>
                                        <span>KAM Account</span>
                                        <strong>{{ shipmentKamLabel() }}</strong>
                                    </div>
                                </div>
                                }
                            </div>

                            <div class="info-block">
                                <div class="block-heading"><i class="fa-solid fa-truck"></i><span>Vehicle</span></div>
                                @if (shipment?.vehicleParaPack?.vehicleType) {
                                <div class="media-line">
                                    <img [src]="shipment.vehicleParaPack.vehicleConfig?.image || 'https://cdn-icons-png.flaticon.com/512/870/870181.png'" alt="">
                                    <div>
                                        <strong>{{ shipment.vehicleParaPack.vehicleType.name }}</strong>
                                        <span>{{ shipment.vehicleParaPack.vehicleConfig?.name || 'Any configuration' }}</span>
                                    </div>
                                </div>
                                <dl>
                                    <div><dt>Capacity</dt><dd>{{ shipment.vehicleParaPack.vehicleCapacity?.name || 'Not set' }}</dd></div>
                                    <div><dt>Requested</dt><dd>{{ shipment.quantityRequired || 0 }} trucks</dd></div>
                                </dl>
                                } @else {
                                <p class="empty-copy">Vehicle details unavailable.</p>
                                }
                            </div>

                            <div class="info-block">
                                <div class="block-heading"><i class="fa-solid fa-boxes-stacked"></i><span>Cargo</span></div>
                                @if ((shipment?.payloadItemList?.length ?? 0) > 0) {
                                <div class="media-line">
                                    <img [src]="shipment.payloadItemList[0].itemType?.image || 'https://cdn-icons-png.flaticon.com/512/3285/3285047.png'" alt="">
                                    <div>
                                        <strong>{{ shipment.payloadItemList[0].itemType?.name || 'Cargo' }}</strong>
                                        <span>{{ payloadQuantityLabel(shipment.payloadItemList[0]) }}</span>
                                    </div>
                                </div>
                                <dl>
                                    <div><dt>Total weight</dt><dd>{{ shipmentPayloadWeightSummary() }}</dd></div>
                                    <div><dt>Service</dt><dd>{{ serviceCategoryLabel() }}</dd></div>
                                </dl>
                                } @else {
                                <p class="empty-copy">Cargo details unavailable.</p>
                                }
                            </div>
                        </div>

                        <div class="strategy-strip">
                            <div><span>Booking</span><strong>{{ showDate(shipment.requestedBookingTime) || 'Not scheduled' }}</strong></div>
                            <div><span>Route Type</span><strong>{{ shipment.routeType || 'DOMESTIC' }}</strong></div>
                            <div><span>Distance</span><strong>{{ routeDistanceLabel() }}</strong></div>
                            <div><span>ETA</span><strong>{{ routeDurationLabel() }}</strong></div>
                        </div>
                            </div>

                            <aside class="overview-delivery-rail" aria-label="Confirmed deliveries">
                                <div class="overview-delivery-rail-header">
                                    <div>
                                        <span>{{ 'pages.shipmentDetail.confirmedDeliveries.title' | transloco }}</span>
                                        <strong>{{ orderDeliveryList.length }}</strong>
                                    </div>
                                    <p-tag [value]="fulfillmentPercent() + '% fulfilled'" severity="success"></p-tag>
                                </div>

                                @if (orderDeliveryList.length > 0) {
                                <div class="overview-delivery-list">
                                    @if (shipmentCashError) {
                                    <div class="shipment-secondary-state shipment-secondary-state--error" role="alert">Delivery cash sources could not be loaded. <button type="button" (click)="retryShipmentCashRequests()">Retry</button></div>
                                    }
                                    @for (orderDelivery of orderDeliveryList; track orderDelivery.deliveryId || orderDelivery.deliveryNumber) {
                                    @if (deliveryProgress(orderDelivery); as progress) {
                                    <article class="overview-delivery-card">
                                        <div class="overview-delivery-card-top">
                                            <div>
                                                <span>{{ 'pages.shipmentDetail.confirmedDeliveries.delivery' | transloco }}</span>
                                                <strong>{{ orderDelivery.deliveryNumber || ('#' + orderDelivery.deliveryId) }}</strong>
                                            </div>
                                            <p-tag [value]="progress.label" [severity]="progress.severity"></p-tag>
                                        </div>

                                        <div class="overview-delivery-fields">
                                            <div>
                                                <i class="fa-solid fa-id-card"></i>
                                                <span>{{ getDriverName(orderDelivery) }}</span>
                                            </div>
                                            <div>
                                                <i class="fa-solid fa-truck"></i>
                                                <span>{{ getVehicleLabel(orderDelivery) }}</span>
                                            </div>
                                            <div>
                                                <i class="fa-solid fa-signal"></i>
                                                <span>{{ progress.summary || formatStatusLabel(orderDelivery.workflowState || orderDelivery.jobStatus) }}</span>
                                            </div>
                                            @if (cashRequestForDelivery(orderDelivery.deliveryId); as cash) {
                                            <div>
                                                <i class="pi pi-wallet"></i>
                                                <span>{{ cash.purpose === 'COMPANY_EXPENSE_FLOAT' ? 'Company expense float' : 'Advance against pay' }} · {{ cash.amount }} {{ cash.currencycode }} · {{ cash.status }}<br>Cash from {{ cash.boxname || 'source not assigned' }}{{ cash.locationname ? ' · ' + cash.locationname : '' }}</span>
                                            </div>
                                            }
                                        </div>

                                        <div class="overview-delivery-card-footer">
                                            <small>Updated {{ getJobUpdatedAt(orderDelivery) }}</small>
                                            <button pButton type="button" icon="pi pi-arrow-right" [label]="'pages.shipmentDetail.confirmedDeliveries.view' | transloco"
                                                severity="secondary" [outlined]="true" size="small"
                                                (click)="viewDeliveryPage(orderDelivery)"></button>
                                            @if (cashRequestForDelivery(orderDelivery.deliveryId)) {
                                            <a [routerLink]="['/accounts/enterprise/workforce-finance']" [queryParams]="{ tab: 'PETTY_CASH', deliveryId: orderDelivery.deliveryId }">{{ 'pages.shipmentDetail.confirmedDeliveries.cashHandoff' | transloco }}</a>
                                            }
                                        </div>
                                    </article>
                                    }
                                    }
                                </div>
                                } @else {
                                <div class="overview-delivery-empty">
                                    <i class="fa-solid fa-truck-ramp-box"></i>
                                    <strong>No confirmed deliveries</strong>
                                    <span>Confirmed trips will appear here after dispatch.</span>
                                </div>
                                }

                            </aside>
                        </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="1">
                    @if (shipmentRouteSegmentsLoading) {
                    <div class="shipment-secondary-state" role="status">Loading route distances…</div>
                    } @else if (shipmentRouteSegmentsError) {
                    <div class="shipment-secondary-state shipment-secondary-state--error" role="alert">
                        Route distances could not be loaded. <button type="button" (click)="retryShipmentRouteSegments()">Retry</button>
                    </div>
                    }
                    <app-shipment-route-panel
                        [waypoints]="waypointList"
                        [deliveryRoutes]="deliveryRoutes"
                        [manualOrderMode]="manualWaypointOrderMode"
                        [orderDirty]="waypointOrderDirty"
                        [orderSaving]="waypointOrderSaveInProgress"
                        [addingWaypoint]="addWaypointInProgress"
                        [canCreateWaypoints]="permissionService.hasPermission(app_permissions.shipments.waypoints.create) && !isCancelledShipment()"
                        [canEditWaypoints]="permissionService.hasPermission(app_permissions.shipments.waypoints.edit) && !isCancelledShipment()"
                        [hasReturnWaypoint]="hasReturnWaypoint()"
                        [returnStatusLabel]="returnWaypointStatusLabel()"
                        [returnStatusSeverity]="returnWaypointStatusSeverity()"
                        [driverResidenceLabel]="driverResidenceLabel()"
                        [canAddDriverHomeReturn]="canAddDriverResidenceReturnWaypoint() && !isCancelledShipment()"
                        [mapUrl]="getStaticMapUrl()"
                        [routeDistanceLabel]="routeDistanceLabel()"
                        [routeDurationLabel]="routeDurationLabel()"
                        [waypointDisplayType]="routeWaypointDisplayType"
                        [waypointTypeSeverity]="routeWaypointTypeSeverity"
                        [waypointMapsUrl]="routeWaypointMapsUrl"
                        [waypointAddress]="routeWaypointAddress"
                        [waypointSegmentDistance]="routeWaypointSegmentDistance"
                        [waypointSegmentDuration]="routeWaypointSegmentDuration"
                        (command)="onRouteCommand($event)">
                    </app-shipment-route-panel>
                </p-tabpanel>

                <p-tabpanel [value]="2">
                    <app-shipment-dispatch-panel
                        [shipment]="shipment"
                        [pendingJobs]="orderJobList"
                        [deliveries]="orderDeliveryList"
                        [operationStatuses]="deliveryOperationStatuses()"
                        [invokeInProgress]="invokeDriverInProgress"
                        [confirmInProgress]="confirmDriverInProgress"
                        [canInvoke]="canInvokeAnyPendingJob() && !isCancelledShipment()"
                        [canConfirm]="canConfirmAnyPendingJob() && !isCancelledShipment()"
                        [canEdit]="permissionService.hasPermission(app_permissions.shipments.deliveries.edit) && !isCancelledShipment()"
                        [canViewCommercials]="canViewShipmentPricing()"
                        [pickupLabel]="shipment.sourceLocation?.name || pickupLocality || 'Pickup pending'"
                        [dropoffLabel]="shipment.destinationLocation?.name || dropoffLocality || 'Dropoff pending'"
                        (command)="onDispatchCommand($event)">
                    </app-shipment-dispatch-panel>
                </p-tabpanel>

                <p-tabpanel [value]="3">
                    <section class="workspace-section">
                        <app-payload-ledger
                            [items]="shipment?.payloadItemList || []"
                            [releasePartyLabels]="releasePartyLabels"
                            [configuration]="shipmentPayloadLedgerConfiguration"
                            [extracting]="payloadExtractionInProgress"
                            (extractDocument)="onShipmentPayloadDocumentSelected($event)"
                            (add)="payloadLineDialog.openCreate()"
                            (edit)="payloadLineDialog.openEdit($event.item)"
                            (remove)="payloadLineDialog.confirmDelete($event.item)">
                        </app-payload-ledger>
                    </section>
                    <app-payload-line-command-dialog #payloadLineDialog
                        [shipmentId]="shipmentId"
                        [shipment]="shipment"
                        [payloadTypes]="payloadTypes"
                        [uomList]="uomList"
                        [weightUnits]="weightUnitList"
                        [disabled]="isCancelledShipment()"
                        (changed)="onShipmentPayloadChanged($event)">
                    </app-payload-line-command-dialog>
                </p-tabpanel>
                <p-tabpanel [value]="4" *ngIf="canViewShipmentPricing()">
                    <app-shipment-financials-panel
                        [shipment]="shipment"
                        [deliveryById]="orderDeliveryMap"
                        [tripCostRefreshKey]="tripCostRefreshKey"
                        [canEditCharges]="permissionService.hasPermission(app_permissions.shipments.charges.create) && !isCancelledShipment()"
                        (command)="onFinancialsCommand($event)">
                    </app-shipment-financials-panel>
                </p-tabpanel>

                <p-tabpanel [value]="5">
                    <app-shipment-files-panel
                        [files]="orderFilesList"
                        [deliveryById]="orderDeliveryMap"
                        [jobById]="shipmentJobMap"
                        [shipmentDeliveries]="shipment?.deliveries || []"
                        [operationStatuses]="deliveryOperationStatuses()"
                        [canManageFiles]="permissionService.hasPermission(app_permissions.shipments.files.create) && !isCancelledShipment()"
                        (command)="onFilesCommand($event)">
                    </app-shipment-files-panel>
                </p-tabpanel>

                <p-tabpanel [value]="6">
                    <app-shipment-people-panel
                        [nominations]="nominationEntities"
                        [consolidationEnabled]="isZeroSellConsolidation()"
                        [consolidation]="consolidation"
                        [consolidationLoading]="consolidationLoading"
                        [consolidationError]="consolidationError"
                        (retryConsolidation)="retryConsolidation()"
                        [canManageWatchers]="permissionService.hasPermission(app_permissions.shipments.nominations.create) && !isCancelledShipment()"
                        [canNotify]="permissionService.hasPermission(app_permissions.shipments.nominations.notify) && !isCancelledShipment()"
                        (command)="onPeopleCommand($event)">
                    </app-shipment-people-panel>
                </p-tabpanel>

                <p-tabpanel [value]="7">
                    @if (shipmentNotesLoading) {
                    <div class="shipment-secondary-state" role="status">Loading notes…</div>
                    } @else if (shipmentNotesError) {
                    <div class="shipment-secondary-state shipment-secondary-state--error" role="alert">
                        Notes could not be loaded. <button type="button" (click)="retryShipmentNotes()">Retry</button>
                    </div>
                    }
                    <app-shipment-notes-panel
                        [remarksHtml]="shipmentRemarksHtml"
                        [saving]="saveShipmentRemarksInProgress"
                        [readonly]="isCancelledShipment() || shipmentNotesLoading || shipmentNotesError"
                        (remarksChanged)="shipmentRemarksHtml = $event"
                        (command)="onNotesCommand($event)">
                    </app-shipment-notes-panel>
                    @if (shipmentRemarksFeed.entries.length > 0) {
                    <section class="notes-context-feed">
                        <h3>{{ 'pages.shipmentDetail.overview.relatedNotes' | transloco }}</h3>
                        <p>Read-only context from shipment, delivery, and site records.</p>
                        @for (entry of shipmentRemarksFeed.entries; track entry.scope + '-' + (entry.deliveryId || '') + '-' + (entry.stopId || entry.waypointId || '') + '-' + $index) {
                        <article class="note-context-entry">
                            <strong>{{ entry.scope === 'SHIPMENT' ? 'Shipment' : entry.scope === 'DELIVERY' ? (entry.deliveryNumber || 'Delivery') : ((entry.deliveryNumber ? entry.deliveryNumber + ' · ' : '') + (entry.locationName || 'Site')) }}</strong>
                            <div [innerHTML]="entry.remarksHtml"></div>
                        </article>
                        }
                    </section>
                    }
                </p-tabpanel>

            </p-tabpanels>
        </p-tabs>
    </app-page-data-panel>
        </main>

        <aside class="business-action-pane" [attr.aria-label]="'pages.shipmentDetail.actions.panelTitle' | transloco">
            <header class="business-action-pane__header">
                <span class="business-action-pane__eyebrow">{{ 'pages.shipmentDetail.actions.panelEyebrow' | transloco }}</span>
                <h2>{{ 'pages.shipmentDetail.actions.panelTitle' | transloco }}</h2>
                <p>{{ 'pages.shipmentDetail.actions.panelSubtitle' | transloco }}</p>
            </header>

            <section class="business-action-group business-action-group--primary" *ngIf="canPostToAccounts()">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-arrow-right-arrow-left"></i>
                    <div>
                        <strong>{{ 'pages.shipmentDetail.actions.financeGroup' | transloco }}</strong>
                        <span>{{ 'pages.shipmentDetail.actions.financeGroupHint' | transloco }}</span>
                    </div>
                </div>
                <p-button
                    [label]="shipment.shipmentStatus === 'POSTED_TO_ACCOUNTS' ? 'Update Accounts' : ('pages.shipmentDetail.actions.postToAccounts' | transloco)"
                    icon="fa-solid fa-file-invoice-dollar" severity="success"
                    [loading]="postingToAccounts" [disabled]="postingToAccounts"
                    (onClick)="postToAccounts()"></p-button>
            </section>

            <section class="business-action-group business-action-group--commercial"
                *ngIf="canShowCommercialAction()">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-cart-shopping"></i>
                    <div>
                        <strong>{{ 'pages.shipmentDetail.actions.commercialGroup' | transloco }}</strong>
                        <span>{{ 'pages.shipmentDetail.actions.commercialGroupHint' | transloco }}</span>
                    </div>
                </div>
                <app-execution-sales-order-button sourceType="SHIPMENT" [sourceId]="shipment.shipmentId"
                    [owningCompanyId]="shipment.owningCompany?.id || sessionStorageService.getCompany()?.id"
                    [sourceLabel]="shipment.shipmentNumber"
                    [allowCreate]="!isPostedToAccounts()"></app-execution-sales-order-button>
            </section>

            <section class="business-action-group" *ngIf="!isCancelledShipment()">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-truck-fast"></i>
                    <div>
                        <strong>{{ 'pages.shipmentDetail.actions.operationsGroup' | transloco }}</strong>
                        <span>{{ 'pages.shipmentDetail.actions.operationsGroupHint' | transloco }}</span>
                    </div>
                </div>
                <p-button *ngIf="canAddOrderReleasesToShipment()" label="Add Order Releases" icon="fa-solid fa-link" severity="secondary" [outlined]="true"
                    (onClick)="openShipmentReleaseAttachment()"></p-button>
                <p-button *ngIf="canAssignDriverVehicleFromCommandCentre()" label="Assign Driver/Vehicle" icon="fa-solid fa-people-arrows"
                    (onClick)="generateDeliveries()"></p-button>
                <p-button *ngIf="canChangeRequestedTruckCount()" label="Requested Trucks" icon="fa-solid fa-truck"
                    severity="secondary" [outlined]="true" (onClick)="openRequestedTruckCountDialog()"></p-button>
                <p-button *ngIf="canCorrectBillToParty()" label="Correct Bill-to Party" icon="pi pi-pencil"
                    severity="secondary" [outlined]="true" (onClick)="openBillToPartyCorrection()"></p-button>
                <p-button *ngIf="canCorrectSchedule()" [label]="'pages.shipmentDetail.scheduleCorrection.action' | transloco" icon="pi pi-calendar"
                    severity="secondary" [outlined]="true" (onClick)="openScheduleCorrection()"></p-button>
            </section>

            <section class="business-action-group">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    <div>
                        <strong>{{ 'pages.shipmentDetail.actions.navigationGroup' | transloco }}</strong>
                        <span>{{ 'pages.shipmentDetail.actions.navigationGroupHint' | transloco }}</span>
                    </div>
                </div>
                <p-button [label]="'pages.shipmentDetail.actions.simpleView' | transloco" icon="pi pi-bolt" severity="secondary" [outlined]="true"
                    (onClick)="switchToSimpleMode()"></p-button>
                <p-splitButton *ngIf="hasMultipleLogisticsProjects()" [label]="'pages.shipmentDetail.actions.openProject' | transloco" icon="fa-solid fa-briefcase"
                    severity="secondary" [outlined]="true" [model]="logisticsProjectMenuItems()"
                    (onClick)="openPrimaryLogisticsProject()"></p-splitButton>
                <p-button *ngIf="hasLogisticsProject() && !hasMultipleLogisticsProjects()" [label]="'pages.shipmentDetail.actions.openProject' | transloco" icon="fa-solid fa-briefcase" severity="secondary" [outlined]="true"
                    [routerLink]="logisticsProjectRoute()"></p-button>
            </section>

            <section class="business-action-group business-action-group--danger"
                *ngIf="permissionService.hasPermission(app_permissions.shipments.cancel)">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    <div>
                        <strong>{{ 'pages.shipmentDetail.actions.dangerGroup' | transloco }}</strong>
                        <span>{{ 'pages.shipmentDetail.actions.dangerGroupHint' | transloco }}</span>
                    </div>
                </div>
                <p-button [label]="'pages.shipmentDetail.actions.cancelShipment' | transloco" icon="fa-solid fa-ban" severity="danger"
                    (onClick)="cancelShipment()"
                    [disabled]="shipment.shipmentStatus === 'CANCELLED' || shipment.shipmentStatus === 'COMPLETED' || shipment.shipmentStatus === 'POSTED_TO_ACCOUNTS' || shipment.shipmentStatus === 'INVOICED' || shipment.shipmentStatus === 'CLOSED'"></p-button>
            </section>
        </aside>
    </div>
</app-page-shell>

<app-waypoint-dialog [addWaypointDialogVisible]="addWaypointDialogVisible" [newWaypoint]="newWaypoint"
    [companyLocations]="companyLocations" [addWaypointInProgress]="addWaypointInProgress"
    [mode]="waypointDialogMode" [purpose]="waypointDialogPurpose"
    (onHide)="hideAddWaypointDialog()" (onSave)="saveNewWaypoint($event)">
</app-waypoint-dialog>

<app-charge-line-dialog *ngIf="canViewShipmentPricing()" [chargeLineDialogVisible]="chargeLineDialogVisible" [shipment]="shipment"
    [orderDeliveryList]="orderDeliveryList" [selectedChargeLine]="selectedChargeLine"
    [saveChargeLineInProgress]="saveChargeLineInProgress" (onHide)="hideChargeLineDialog()"
    (onSave)="saveChargeLine($event)">
</app-charge-line-dialog>


<app-shipment-dispatch-dialogs
    [watcherVisible]="addWatcherDialogVisible"
    [watcherOptions]="watcherContactOptions"
    [selectedWatcher]="selectedWatcher"
    [watcherLoading]="watcherOptionsLoading"
    [watcherSaving]="addWatcherInProgress"
    [amendmentVisible]="releaseAmendmentDialogVisible"
    [shipmentReleaseMode]="shipmentReleaseMode"
    [shipmentNumber]="shipment.shipmentNumber"
    [amendmentStep]="releaseAmendmentStep"
    [amendmentLoading]="releaseAmendmentLoading"
    [amendmentApplying]="releaseAmendmentApplying"
    [amendmentDelivery]="selectedDeliveryForAmendment"
    [amendmentCanApply]="permissionService.hasPermission(app_permissions.shipments.deliveries.edit)"
    [releasePool]="releasePool"
      [releaseSearch]="releaseSearch"
      [releasePage]="releasePage"
      [releaseTotalPages]="releaseTotalPages"
      [releaseTotal]="releaseTotal"
      [releasePoolError]="releasePoolError"
    [selectedReleaseIds]="selectedReleaseIds"
    [amendmentPreview]="releaseAmendmentPreview"
      [attachmentPreview]="shipmentAttachmentPreview"
      [zeroSellShipment]="shipment.billingMode === 'CONSOLIDATED_ZERO_SELL'"
    [amendmentHistory]="releaseAmendmentHistory"
    [amendmentReason]="releaseAmendmentReason"
    [amendmentBuyingPrice]="releaseAmendmentBuyingPrice"
    [amendmentSellingPrice]="releaseAmendmentSellingPrice"
    [cancellationVisible]="deliveryCancellationDialogVisible"
    [cancellationDelivery]="deliveryToCancel"
    [cancellationReason]="deliveryCancellationReason"
    [cancellationSaving]="deliveryCancellationInProgress"
    (command)="onDispatchDialogCommand($event)">
</app-shipment-dispatch-dialogs>
<app-shipment-accounts-review-dialog [(visible)]="accountsReviewVisible" [shipmentId]="shipmentId" [shipmentDetail]="shipment" [posting]="postingToAccounts" (confirmed)="confirmAccountsPost()"></app-shipment-accounts-review-dialog>


